<template>
<div class="min-height">
    <div class="comingsoon">
        <div class="comingsoon__title">Coming soon</div>
        <div class="comingsoon__text">Join the <a href="https://discord.gg/vu9v97K2Aj">discord</a> for updates</div>
    </div>
</div>
</template>

<style>
    .comingsoon {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .comingsoon__title {
        font-size: 7rem;
    }

    .comingsoon__text {
        font-size: 2.25rem;
        text-align: center;
    }

    .comingsoon__text a {
        color: #00c0ff;
    }
</style>

<script>
/*const dsteem = window.dhive;

let opts = {};

//connect to production server
opts.addressPrefix = 'STM';
opts.chainId =
    'beeab0de00000000000000000000000000000000000000000000000000000000';

//connect to server which is connected to the network/production
const client = new dsteem.Client('https://api.hive.blog');

let stream;

async function start_stream() {
    stream = client.blockchain.getBlockStream();
    stream
        .on('data', function(block) {
            // console.log(`${block.transactions[0].operations[0][1].id} - ${block.transactions[0].operations[0][1].json}`);
            block.transactions.forEach(trx => {
                if (trx.operations[0][0] === "custom_json") {
                    let sp_trx = trx.operations[0][1];
                    if (sp_trx.id === "sm_market_rent") {
                        console.log(sp_trx.json);
                    }
                }
            });
        });
}*/

export default {
    beforeCreate() {
        //start_stream();
    }
}
</script>
